import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddStandard, IStandard } from "../../Stream.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddStream = () => {
  const [formData, setFormData] = useState<IAddStandard>({
    languageName: "",
    standard: "",
    courseName: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [standard, setStandard] = useState([]);
  const [standardData, setStandardData] = useState<IStandard[]>([]); // State to hold fetched standards
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const navigate = useNavigate();

  // Fetch data when the component mounts
  useEffect(() => {
    fetchData();
    fetchCoursesAndLanguages(); // Fetch courses and languages
  }, []);

  // Fetch standard data
  const fetchData = async () => {
    try {
      const result = await ApiService({
        method: "GET",
        endpoint: apiPaths.getCourse,
      });

      setStandardData(result); // Set the fetched standard data
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch standard data."); // Show error toast
    }
  };

  // Fetch courses and languages data
  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [standardsResponse] = await Promise.all([
        // ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        // ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      console.log("Standard res : ",standardsResponse);
      setStandard(standardsResponse)
      // setCourses(coursesResponse);
      // setLanguages(languagesResponse);
    } catch (error) {
      console.error("Error fetching courses and languages:", error);
      toast.error("Failed to fetch courses or languages."); // Show error toast
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  
  const handleSubmit: SubmitHandler<IAddStandard> = async () => {
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createCourse}`,
        data: {
          courseName: formData.courseName,
          standard: formData.standard,
        },
      });

      if (response !== "undefined") {
        toast.success("Standard added successfully", {
          duration: 10000,
        });
        navigate("/stream"); // Redirect after successful update
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000,
      });
      console.error("Error updating standard:", error);
    }
  };

  const handleCancel = () => {
    navigate("/stream");
  };

  return {
    loading,
    formData,
    standard,
    standardData, // Expose fetched standard data
    courses,
    languages,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddStream;
